/** O texto do aviso de e-mail parado na fila de triagem (`TP-037`), sem nenhum dado de paciente. */

import { TENTATIVAS_QUE_ESGOTAM, type ResumoDasFalhasDeEmail } from '../../shared/falhasDeEmail/resumo';

/** "3 e-mails parados (2 na triagem, 1 na coleta). 1 deles já falhou 5 vezes ou mais." */
export function textoDoAviso(resumo: ResumoDasFalhasDeEmail): string {
  const parados = resumo.abertas === 1 ? '1 e-mail parado' : `${String(resumo.abertas)} e-mails parados`;
  const etapas = [
    resumo.triagem > 0 ? `${String(resumo.triagem)} na triagem` : null,
    resumo.coleta > 0 ? `${String(resumo.coleta)} na coleta` : null,
  ].filter((etapa) => etapa !== null);
  const frase = etapas.length > 0 ? `${parados} (${etapas.join(', ')}).` : `${parados}.`;

  if (resumo.esgotadas === 0) return frase;
  const esgotadas = resumo.esgotadas === 1 ? '1 deles já falhou' : `${String(resumo.esgotadas)} deles já falharam`;
  return `${frase} ${esgotadas} ${String(TENTATIVAS_QUE_ESGOTAM)} vezes ou mais.`;
}
